import LocationSVG from 'app/assets/icons/listing/location-gradient.svg'
import Skeleton from 'app/components/base/Skeleton'
import Stack, { StackProps } from 'app/components/base/Stack'
import Text, { TextProps } from 'app/components/base/Text'
import useOpenExternalLink from 'app/hooks/useOpenExternalLink'
import { IS_NATIVE_APP } from 'app/utils/constants/env.constants'

interface LocationProps {
  location: string | null
  sx?: StackProps['sx']
  loading?: boolean
  textVariant?: TextProps['variant']
  textColor?: TextProps['color']
  withGoogleMapLink?: boolean
}

const Location: RFC<LocationProps> = ({
  location,
  sx,
  loading,
  textVariant = 'subtitle1',
  textColor = 'text.third',
  withGoogleMapLink
}) => {
  const { openLink } = useOpenExternalLink()

  const openMap = () => {
    openLink({
      link: `https://www.google.com/maps/place/${location}`,
      withoutWebView: true
    })
  }

  return (
    <Stack direction="row" spacing={1} sx={{ alignItems: 'center', ...sx }}>
      <Skeleton loading={loading} width="40%">
        {!!location && (
          <Stack sx={{ flexDirection: 'row', alignItems: 'center' }}>
            <LocationSVG />

            <Text
              variant={textVariant}
              component="p"
              color={textColor}
              {...(withGoogleMapLink && { onClick: openMap })}
              sx={{
                marginLeft: 1,
                ...(withGoogleMapLink && {
                  color: textColor,

                  ...(IS_NATIVE_APP && {
                    textDecorationLine: 'underline',
                    textDecorationStyle: 'solid',
                    textDecorationColor: textColor
                  }),
                  ...(!IS_NATIVE_APP && {
                    cursor: 'pointer',
                    textDecoration: 'underline',

                    '&:hover': {
                      color: 'secondary.dark',
                      textDecoration: 'none'
                    }
                  })
                })
              }}
            >
              {location}
            </Text>
          </Stack>
        )}
      </Skeleton>
    </Stack>
  )
}

export default Location
